import {SODeleteDeficiency} from '../../core/deficiency/so-delete-deficiency';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteDeficiency extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteDeficiency;
}